import { z } from 'zod';
import { dateStr, objectIdStr } from './common.js';
import { stationKey } from './station.js';

/**
 * One document per batch × station × day. Replaces both the dotted-key
 * `jobs.stations.CNC.hours_booked.<date>` map and the parallel `stationbookings`
 * counter that could drift apart from it.
 */
export const booking = z.object({
  _id: objectIdStr,
  jobId: objectIdStr,
  batchId: objectIdStr,
  stationKey,
  date: dateStr,
  hours: z.number().min(0),
  /** A pinned booking is immovable: every scheduling operation treats it as fixed load. */
  pinned: z.boolean().default(false),
});
export type Booking = z.infer<typeof booking>;

export const bookingPatch = z.object({
  pinned: z.boolean().optional(),
  date: dateStr.optional(),
  hours: z.number().min(0).optional(),
});
export type BookingPatch = z.infer<typeof bookingPatch>;

/** Pinning a whole job's plan is all-or-nothing, so `pinned` is required here. */
export const planPinPatch = z.object({ pinned: z.boolean() });
export type PlanPinPatch = z.infer<typeof planPinPatch>;
